import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { CustomCellComponent } from '@vendasta/galaxy/table';
import { TaskQueueService } from '../../../crm-components/task-queue/task-queue.service';
import { combineLatest, of } from 'rxjs';
import { CrmInjectionToken } from '@galaxy/crm/static';
import { map } from 'rxjs/operators';

export interface TaskNameData {
  name: string;
  id: string;
}

@Component({
  template: `@if (showAsLink$ | async) {
      <a (click)="openTask()">{{ name }}</a>
    } @else {
      {{ name }}
    }`,
  imports: [CommonModule],
})
export class TaskNameCellComponent extends CustomCellComponent {
  protected name = '';
  protected taskId = '';

  private readonly taskQueueService = inject(TaskQueueService);
  private readonly config = inject(CrmInjectionToken);

  protected readonly showAsLink$ = combineLatest([
    this.taskQueueService.hasAccessToTaskQueue$,
    this.config.multiLocationContext$ || of(null),
  ]).pipe(map(([hasAccess, context]) => hasAccess && !context?.groupId));

  set value(newValue: TaskNameData) {
    this.name = newValue.name;
    this.taskId = newValue.id;
  }

  protected openTask(): void {
    this.taskQueueService.startQueue([this.taskId]);
  }
}
